import { compareAsc, getDay, isToday, isTomorrow, startOfDay } from 'date-fns'

const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

export const getDayName = date => {
  if (isToday(date)) {
    return 'Today'
  } else if (isTomorrow(date)) {
    return 'Tomorrow'
  } else {
    return days[getDay(date)]
  }
}

export const isCurrentlyDinnerTime = () => compareAsc(new Date(), getDinnerStartTime()) >= 0

/**
 * Gets the time of day for a given date when Dinner deliveries begin.
 * @param {*} date The date to get the dinner start time for. Defauts to today.
 */
export const getDinnerStartTime = (date = new Date()) => {
  const dinnerStartTime = startOfDay(date)
  dinnerStartTime.setHours(15)
  dinnerStartTime.setMinutes(0)
  dinnerStartTime.setSeconds(0)
  return dinnerStartTime
}

/**
 * For a given delivery, determines if the dropoff date is a dinner delivery.
 * This should probably be a back end thing but its a quick win for now.
 * @param {*} delivery The delivery dropoff. See the delivery.js redux store.
 */
export const isDinnerDelivery = delivery => {
  const dinnerStartTime = getDinnerStartTime(delivery.dropoffDate)
  return compareAsc(delivery.dropoffDate, dinnerStartTime) >= 0
}
